import { useEffect, useState } from 'react';

/** mirrors the app-wide very-small-screen breakpoint used in mobile media queries */
const QUERY = '(max-width: 480px)';

/**
 * Returns true when the viewport is phone-sized (<= 480px).
 *
 * Uses matchMedia rather than a resize listener so consumers only re-render
 * when the 480px threshold is actually crossed - iOS Safari fires window
 * resize events on every URL-bar collapse/expand during scrolling, which
 * would otherwise cause re-render storms in per-item components.
 */
const useIsMobile = () => {
  const [isMobile, setIsMobile] = useState(
    () => typeof window === 'object' && window.matchMedia(QUERY).matches,
  );

  useEffect(() => {
    if (typeof window !== 'object') {
      return undefined;
    }

    const mediaQueryList = window.matchMedia(QUERY);
    const handleChange = (e) => setIsMobile(e.matches);

    /** addListener fallback for older Safari (< 14) */
    if (mediaQueryList.addEventListener) {
      mediaQueryList.addEventListener('change', handleChange);
    } else {
      mediaQueryList.addListener(handleChange);
    }

    return () => {
      if (mediaQueryList.removeEventListener) {
        mediaQueryList.removeEventListener('change', handleChange);
      } else {
        mediaQueryList.removeListener(handleChange);
      }
    };
  }, []);

  return isMobile;
};

export default useIsMobile;
